import { render, staticRenderFns } from "./FlatSearchResults.vue?vue&type=template&id=12727dc8&"
import script from "./FlatSearchResults.vue?vue&type=script&lang=js&"
export * from "./FlatSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./FlatSearchResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports